
import lazyload from "@/directives/lazyload";

import face from "@/assets/images/main/example/social/face.png"
import flickr from "@/assets/images/main/example/social/flickr.png"
import flirt from "@/assets/images/main/example/social/flirt.png"
import luxy from "@/assets/images/main/example/social/luxy.png"
import moco from "@/assets/images/main/example/social/moco.png"
import okupid from "@/assets/images/main/example/social/okupid.png"
import snap from "@/assets/images/main/example/social/snap.png"
import tumblr from "@/assets/images/main/example/social/tumblr.png"
import twitter from "@/assets/images/main/example/social/twitter.png"
import twoo from "@/assets/images/main/example/social/twoo.png"
export default {
  data() {
    return {
      images: {
        face,
        flickr,
        flirt,
        luxy,
        moco,
        okupid,
        snap,
        tumblr,
        twitter,
        twoo
      },
    };
  },
  directives: {
    lazyload,
  },
};
